import { defaultTo } from 'lodash';
import { IModel, Model, ModelRecord } from './Model';

export interface IPrescriptionStatusModel extends IModel {
  prescriptionStatusId: number;
  name: string;
  isOwnedByPetPass: boolean;
  canBeRefilledByPetPass: boolean;
  canBeRecalledByPetPass: boolean;
  canBeCancelledByPetPass: boolean;
}

export class PrescriptionStatusModel
  extends Model
  implements ModelRecord<IPrescriptionStatusModel>
{
  prescriptionStatusId: number;
  name: string;
  isOwnedByPetPass: boolean;
  canBeRefilledByPetPass: boolean;
  canBeRecalledByPetPass: boolean;
  canBeCancelledByPetPass: boolean;
  constructor(params?: Partial<IPrescriptionStatusModel>) {
    super(params);
    this.prescriptionStatusId = defaultTo(params?.prescriptionStatusId, 0);
    this.name = defaultTo(params?.name, '');
    this.isOwnedByPetPass = defaultTo(params?.isOwnedByPetPass, false);
    this.canBeRefilledByPetPass = defaultTo(
      params?.canBeRefilledByPetPass,
      false,
    );
    this.canBeRecalledByPetPass = defaultTo(
      params?.canBeRecalledByPetPass,
      false,
    );
    this.canBeCancelledByPetPass = defaultTo(
      params?.canBeCancelledByPetPass,
      false,
    );
  }
}
